const PLANS_ENDPOINT = {
  PLANS: '/plans',
  RECOMMENDED: '/plans/recommended',
  CREATE_SMART: '/plans/smart',
  COPY: '/plans/copy',
  UPLOAD_IMAGE: '/plans/upload-image/:id'
}

export default PLANS_ENDPOINT
